import { h, Fragment } from 'preact';
import { useMemo } from 'preact/hooks';
import { BirdsnestProductCard } from './BirdsnestProductCard';
import styles from './BirdsnestProductGrid.module.scss';
import { OutfitCard } from './OutfitCard';
import { OutfitSlider } from './OutfitSlider';
import { MockProductItem, MockProductItem2 } from '../../utils/mock/product';
import { isOutfitProduct, isVideoProduct } from '../../utils/helpers';
import { VideoCard } from './VideoCard';
function MerchandisingCard({ tile }) {
    var _a;
    const titleWithBreaks = tile.title.split('\n').map((line, index) => (h(Fragment, { key: index },
        line,
        index < tile.title.split('\n').length - 1 && h("br", null))));
    const slots = (_a = tile.slots) !== null && _a !== void 0 ? _a : 1;
    const gridColumnStyle = slots > 1 ? { gridColumn: `span ${slots}` } : {};
    const linkProps = tile.openInNewWindow
        ? { target: '_blank', rel: 'noopener noreferrer' }
        : {};
    return (h("div", { class: styles.merchandisingTile, style: gridColumnStyle },
        h("a", Object.assign({ href: tile.ctaLink, class: styles.merchandisingLink }, linkProps),
            h("div", { class: styles.merchandisingImage },
                h("div", { class: styles.merchandisingBgColor, style: { backgroundColor: tile.backgroundColor || '#f8f4f1' } }),
                h("div", { class: styles.merchandisingContent },
                    tile.ctaText && (h("div", { class: styles.merchandisingWrapperText },
                        h("h3", { style: { color: tile.color || '#2C2B2B' }, class: styles.merchandisingTitle, dangerouslySetInnerHTML: { __html: tile.title } }),
                        h("span", { class: styles.merchandisingCta, style: { color: tile.color || '#2C2B2B' } }, tile.ctaText))),
                    h("div", { class: styles.merchandisingWrapperImage },
                        (tile === null || tile === void 0 ? void 0 : tile.hightlight) && (h("div", { class: styles.merchandisingIconMatches },
                            h("svg", { width: "77", height: "77", viewBox: "0 0 77 77", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
                                h("path", { d: "M76.7481 35.029C76.4715 31.8679 73.8238 29.1385 69.5127 27.0555C71.4766 22.6887 71.751 18.8965 69.9306 16.2972C68.1105 13.6979 64.4526 12.6588 59.6789 13.01C59.1956 8.24645 57.5372 4.82586 54.6612 3.48486C51.7853 2.14381 48.0981 3.07252 44.1386 5.7646C41.3387 1.88106 38.1908 -0.252611 35.0298 0.0239436C31.8687 0.300509 29.1392 2.94838 27.0561 7.25912C22.6893 5.2955 18.8969 5.02117 16.2976 6.84124C13.6983 8.66126 12.6591 12.3194 13.0102 17.0929C8.24665 17.5762 4.82602 19.2346 3.48493 22.1105C2.14388 24.9863 3.07257 28.6733 5.76472 32.6328C1.88107 35.4326 -0.252658 38.5804 0.0239037 41.7415C0.300455 44.9025 2.94838 47.6321 7.25923 49.715C5.29553 54.0819 5.02117 57.8739 6.84124 60.4733C8.66135 63.0727 12.3195 64.1117 17.0931 63.7607C17.5764 68.524 19.2349 71.9448 22.1109 73.2874C24.9868 74.6284 28.6738 73.6996 32.6334 71.0073C35.4333 74.8911 38.5811 77.0247 41.7423 76.7481C44.9033 76.4716 47.6329 73.8238 49.7158 69.5127C54.0827 71.4766 57.8751 71.751 60.4745 69.931C63.0739 68.1109 64.113 64.4526 63.7618 59.6777C68.5251 59.1944 71.9459 57.536 73.2869 54.6601C74.6283 51.7841 73.6995 48.0973 71.0072 44.1378C74.8911 41.3379 77.0246 38.19 76.7481 35.029Z", fill: tile.hightlightColor })),
                            h("span", { style: { color: tile.highlightTextColor } }, tile === null || tile === void 0 ? void 0 : tile.hightlight))),
                        tile.image && h("img", { src: tile.image, alt: tile.title })))))));
}
export function LoadingSkeleton() {
    return (h("div", { class: styles.skeleton },
        h("div", { class: styles.skeletonImage }),
        h("div", { class: styles.skeletonContent },
            h("div", { class: styles.skeletonLine, style: { width: '40%' } }),
            h("div", { class: styles.skeletonLine, style: { width: '60%' } }),
            h("div", { class: styles.skeletonLine, style: { width: '80%' } }),
            h("div", { class: styles.skeletonLine, style: { width: '50%' } }))));
}
export function BirdsnestProductGrid({ products, loading, layout, merchandisingTiles = [], isModelView = true, meta, enrichedTvProductsById, trackingListId }) {
    var _a, _b;
    const hasOutfitProducts = products.some(isOutfitProduct);
    const merchandisingSource = typeof window !== 'undefined' && ((_a = window.liquidCustom) === null || _a === void 0 ? void 0 : _a.merchandisingSource)
        ? window.liquidCustom.merchandisingSource
        : 'fredhopper_api';
    const enableMockProducts = typeof window !== 'undefined' && ((_b = window.liquidCustom) === null || _b === void 0 ? void 0 : _b.enableMockProducts)
        ? window.liquidCustom.enableMockProducts
        : false;
    const fredhopperMerchandisingTiles = useMemo(() => {
        if (!(meta === null || meta === void 0 ? void 0 : meta.merchandisingApplied))
            return [];
        const merchandisingApplied = meta.merchandisingApplied;
        const inlineBanners = merchandisingApplied.filter((item) => { var _a, _b, _c, _d; return ((_b = (_a = item.rules) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.type) === 'custom' && ((_d = (_c = item.rules) === null || _c === void 0 ? void 0 : _c[0]) === null || _d === void 0 ? void 0 : _d.id) === 'inline_banner'; });
        if (inlineBanners.length === 0)
            return [];
        return inlineBanners.map((bannerData) => {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
            // Fredhopper customContent always has 1 item
            const content = (_a = bannerData.customContent) === null || _a === void 0 ? void 0 : _a[0];
            const customFields = (_c = (_b = content === null || content === void 0 ? void 0 : content['custom-fields']) === null || _b === void 0 ? void 0 : _b['custom-field']) !== null && _c !== void 0 ? _c : [];
            const staticContent = (_e = (_d = content === null || content === void 0 ? void 0 : content['static-content']) === null || _d === void 0 ? void 0 : _d.content) !== null && _e !== void 0 ? _e : [];
            const imageRow = ((_f = customFields.find((f) => f.name === 'image_row')) === null || _f === void 0 ? void 0 : _f.value) || '1';
            const imageColumn = ((_g = customFields.find((f) => f.name === 'image_column')) === null || _g === void 0 ? void 0 : _g.value) || '1';
            const imageProductSlots = ((_h = customFields.find((f) => f.name === 'image_product_slots')) === null || _h === void 0 ? void 0 : _h.value) || '1';
            const imageContent = staticContent.find((c) => c.name === 'image_1');
            const imageUrl = (imageContent === null || imageContent === void 0 ? void 0 : imageContent['content-value']) || '';
            const contentLink = ((_j = imageContent === null || imageContent === void 0 ? void 0 : imageContent['content-link']) === null || _j === void 0 ? void 0 : _j.value) || '#';
            const openInNewWindow = (_l = (_k = imageContent === null || imageContent === void 0 ? void 0 : imageContent['content-link']) === null || _k === void 0 ? void 0 : _k['open-in-new-window']) !== null && _l !== void 0 ? _l : false;
            const position = (parseInt(imageRow) - 1) * 4 + (parseInt(imageColumn) - 1);
            const rule = (_m = bannerData.rules) === null || _m === void 0 ? void 0 : _m[0];
            return {
                id: (_o = rule === null || rule === void 0 ? void 0 : rule.id) !== null && _o !== void 0 ? _o : '',
                title: (_p = rule === null || rule === void 0 ? void 0 : rule.name) !== null && _p !== void 0 ? _p : '',
                ctaText: '',
                ctaLink: contentLink,
                openInNewWindow: openInNewWindow,
                backgroundColor: '#FFFFFF',
                color: '#333',
                position: position,
                image: imageUrl,
                hightlightColor: '#000',
                highlightTextColor: '#FFF',
                hightlight: '',
                slots: parseInt(imageProductSlots),
                specificColection: null
            };
        });
    }, [meta]);
    const activeMerchandisingTiles = merchandisingSource === 'fredhopper_api'
        ? fredhopperMerchandisingTiles
        : merchandisingTiles;
    const useItemSlider = false;
    const sliderProducts = useMemo(() => {
        if (!useItemSlider) {
            return [];
        }
        const maxSliderItems = 5;
        return products.slice(0, Math.min(products.length, maxSliderItems));
    }, [products, useItemSlider]);
    const sliderInsertionIndex = 4; // 5th position (1-based)
    if (loading) {
        const skeletonCount = Math.max(products.length, 12);
        return (h("div", { class: styles.productGrid + (hasOutfitProducts ? ` ${styles.gridAlternativeLayout}` : "") }, Array.from({ length: skeletonCount }).map((_, i) => (h(LoadingSkeleton, { key: i })))));
    }
    const gridItems = [];
    let productIndex = 0;
    let tileIndex = 0;
    const currentPath = typeof window !== 'undefined' ? window.location.pathname : '';
    const filteredTiles = activeMerchandisingTiles.filter((tile) => {
        var _a, _b;
        const url = (_b = (_a = tile.specificColection) === null || _a === void 0 ? void 0 : _a.url) === null || _b === void 0 ? void 0 : _b.trim();
        if (!url)
            return true;
        return currentPath.includes(url);
    });
    const sortedTiles = [...filteredTiles].sort((a, b) => a.position - b.position);
    for (let i = 0; productIndex < products.length || tileIndex < sortedTiles.length; i++) {
        const currentTile = sortedTiles[tileIndex];
        if (!currentTile) {
            if (productIndex < products.length) {
                gridItems.push({ type: 'product', data: products[productIndex] });
                productIndex++;
            }
            continue;
        }
        const pos = typeof currentTile.position === 'number' && currentTile.position >= 0
            ? currentTile.position
            : 0;
        if (pos === i) {
            gridItems.push({ type: 'tile', data: currentTile });
            tileIndex++;
        }
        else if (productIndex < products.length) {
            gridItems.push({ type: 'product', data: products[productIndex] });
            productIndex++;
        }
        else {
            // Skip tile if it does not have the right position, or its position overlaps with the previous tile
            // gridItems.push({ type: 'tile', data: currentTile });
            tileIndex++;
        }
    }
    if (useItemSlider && sliderProducts.length) {
        const sliderItem = { type: 'slider', data: sliderProducts };
        if (gridItems.length <= sliderInsertionIndex) {
            gridItems.push(sliderItem);
        }
        else {
            gridItems.splice(sliderInsertionIndex, 0, sliderItem);
        }
    }
    let layoutClass = styles.productGrid;
    if (layout.cardLayout === 'gridTwo') {
        layoutClass = styles.productGridTwo;
    }
    else if (layout.cardLayout === 'list') {
        layoutClass = styles.productList;
    }
    else if (layout.cardLayout === 'gridThree') {
        layoutClass = `${styles.productGridThree}`;
    }
    return (h("div", { class: layoutClass + (hasOutfitProducts ? ` ${styles.gridAlternativeLayout}` : "") }, gridItems.map((item, index) => {
        var _a;
        if (item.type === 'tile') {
            return h(MerchandisingCard, { key: `tile-${item.data.id}`, tile: item.data });
        }
        if (item.type === 'slider') {
            return (h("div", { key: "outfit-slider", class: styles.outfitSliderGridItem },
                h(OutfitSlider, { products: item.data, layout: layout, title: "Travel outfits", description: "Curated by your wingbirds, these travel outfits make every journey feel effortlessly stylish.", ctaText: "see all travel outfits", ctaLink: "#" })));
        }
        let productData = item.data;
        if (enableMockProducts) {
            if (index === 0) {
                productData = MockProductItem;
            }
            if (index === 1) {
                productData = MockProductItem2;
            }
        }
        if (item.data.id === '7423428755559') {
            item.data.seeInOutfit = {
                url: '/link-outfit',
                image: 'https://cdn.shopify.com/s/files/1/0627/4731/2231/files/7e298ec8a2333e8f6ab67660386c60e7f114f5b767450c_size_lookbook_updated_at_20230519T090059Z__02679.1684489892.jpg?v=1761716144?width=800',
            };
            item.data.tags = ['coming-soon'];
        }
        // item.data.metafields = [{ namespace: 'custom', key: 'coming_soon', value: 'true' }];
        // item.data.tags = ['coming-soon'];
        if (isOutfitProduct(item.data)) {
            return h(OutfitCard, { key: item.data.id, product: item.data, cardBackground: "#F6F5F2", cellBackground: "#FFFFFF" });
        }
        if (isVideoProduct(item.data)) {
            return h(VideoCard, { key: item.data.id, product: ((_a = enrichedTvProductsById === null || enrichedTvProductsById === void 0 ? void 0 : enrichedTvProductsById[item.data.id]) !== null && _a !== void 0 ? _a : item.data), matchProductCardRatio: true });
        }
        const cardIndex = products.findIndex((p) => p.id === item.data.id);
        return (h(BirdsnestProductCard, { key: item.data.id, product: productData, layout: layout.cardLayout, isModelView: isModelView, trackingListId: trackingListId, trackingPosition: cardIndex >= 0 ? cardIndex : index }));
    })));
}
